import { Component, input } from '@angular/core';

@Component({
  selector: 'app-hero',
  imports: [],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
  readonly image = input.required<string>();
  readonly title = input.required<string>();
  readonly separator = input('citron-separator.png');
}
